import {
  InputAdornment as MUIInputAdornment,
  InputAdornmentProps,
} from '@mui/material';

export { type InputAdornmentProps } from '@mui/material';

export function InputAdornment(props: InputAdornmentProps) {
  return <MUIInputAdornment {...props} />;
}
